export default [
  {
    path: 'notification',
    name: 'notification',
    component: () => import('@/views/pages/notification/Notification.vue'),
    meta: {
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          text: 'Notifications',
          active: true,
        },
      ],
    },
  },
  {
    path: 'notification/:id',
    name: 'notification-view',
    component: () => import('@/views/pages/notification/View.vue'),
    meta: {
      pageTitle: 'Notifications',
      breadcrumb: [
        {
          to: { name: 'notification' },
          text: 'Notifications',
          active: false,
        },
        {
          text: 'Notification',
          active: true,
        },
      ],
    },
  },
]
